import { $ } from './utils/querySelector';

export function formRecaptcha(selector = '.ghwp-form-recaptcha') {
    function onSubmit(event) {
        const form = this;

        if (window.grecaptcha && typeof(window.grecaptcha.execute) === 'function') {
            event.preventDefault();

            window.grecaptcha.execute().then(function(token) {
                form.submit();
            });
        }
    }

    const formElement = $()(selector);
    if (!formElement) return;

    formElement.addEventListener('submit', onSubmit);
}
